import TranslationConstants from 'constants/TranslationConstants'
import { Locales } from 'components/I18n/Constants'
import { captureException } from 'utils/SentryHelpers'


class TranslationActions extends Marty.ActionCreators {
  loadTranslations(locale) {
    return new Promise((resolve, reject) => {
      switch(locale) {
        case Locales.en.key:
          require.ensure(['@driftt/translations/languages/en-US.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/en-US.json'))
            resolve()
          })
          break
        case Locales.es.key:
          require.ensure(['@driftt/translations/languages/es-ES.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/es-ES.json'))
            resolve()
          })
          break
        case Locales.et.key:
          require.ensure(['@driftt/translations/languages/et-EE.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/et-EE.json'))
            resolve()
          })
          break
        case Locales.de.key:
          require.ensure(['@driftt/translations/languages/de-DE.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/de-DE.json'))
            resolve()
          })
          break
        case 'de-DE-formal':
          require.ensure(['@driftt/translations/languages/de-DE.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/de-DE-formal.json'))
            resolve()
          })
          break
        case Locales.hi.key:
          require.ensure(['@driftt/translations/languages/hi-IN.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/hi-IN.json'))
            resolve()
          })
          break
        case Locales.nl.key:
          require.ensure(['@driftt/translations/languages/nl-NL.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/nl-NL.json'))
            resolve()
          })
          break
        case Locales.pt.key:
          require.ensure(['@driftt/translations/languages/pt-PT.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/pt-PT.json'))
            resolve()
          })
          break
        case 'pt-BR':
          require.ensure(['@driftt/translations/languages/pt-BR.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/pt-BR.json'))
            resolve()
          })
          break
        case Locales.sv.key:
          require.ensure(['@driftt/translations/languages/sv-SE.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/sv-SE.json'))
            resolve()
          })
          break
        case Locales.zh.key:
          require.ensure(['@driftt/translations/languages/zh-CN.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/zh-CN.json'))
            resolve()
          })
          break
        case Locales.fr.key:
          require.ensure(['@driftt/translations/languages/fr-FR.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/fr-FR.json'))
            resolve()
          })
          break
        case Locales.it.key:
          require.ensure(['@driftt/translations/languages/it-IT.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/it-IT.json'))
            resolve()
          })
          break
        case Locales.tr.key:
          require.ensure(['@driftt/translations/languages/tr-TR.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/tr-TR.json'))
            resolve()
          })
          break
        case Locales.ru.key:
          require.ensure(['@driftt/translations/languages/ru-RU.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/ru-RU.json'))
            resolve()
          })
          break
        case Locales.pl.key:
          require.ensure(['@driftt/translations/languages/pl-PL.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/pl-PL.json'))
            resolve()
          })
          break
        case Locales.sl.key:
          require.ensure(['@driftt/translations/languages/sl-SI.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/sl-SI.json'))
            resolve()
          })
          break
        case Locales.da.key:
          require.ensure(['@driftt/translations/languages/da-DK.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/da-DK.json'))
            resolve()
          })
          break
        case Locales.fi.key:
          require.ensure(['@driftt/translations/languages/fi-FI.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/fi-FI.json'))
            resolve()
          })
          break

        case Locales.hr.key:
          require.ensure(['@driftt/translations/languages/hr-HR.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/hr-HR.json'))
            resolve()
          })
          break
        case Locales.ko.key:
          require.ensure(['@driftt/translations/languages/ko-KR.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/ko-KR.json'))
            resolve()
          })
          break
        case Locales.nb.key:
          require.ensure(['@driftt/translations/languages/nb-NO.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/nb-NO.json'))
            resolve()
          })
          break
        case Locales.ro.key:
          require.ensure(['@driftt/translations/languages/ro-RO.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/ro-RO.json'))
            resolve()
          })
          break
        case Locales.sr.key:
          require.ensure(['@driftt/translations/languages/sr-SP.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/sr-SP.json'))
            resolve()
          })
          break
        case Locales.th.key:
          require.ensure(['@driftt/translations/languages/th-TH.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/th-TH.json'))
            resolve()
          })
          break
        case Locales.vi.key:
          require.ensure(['@driftt/translations/languages/vi-VN.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/vi-VN.json'))
            resolve()
          })
          break
        case Locales.hu.key:
          require.ensure(['@driftt/translations/languages/hu-HU.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/hu-HU.json'))
            resolve()
          })
          break
        case Locales.is.key:
          require.ensure(['@driftt/translations/languages/is-IS.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/is-IS.json'))
            resolve()
          })
          break
        case Locales.ja.key:
          require.ensure(['@driftt/translations/languages/ja-JP.json'], (require) => {
            this.dispatch(TranslationConstants.TRANSLATION_LOADED, locale, require('@driftt/translations/languages/ja-JP.json'))
            resolve()
          })
          break
        case Locales.ka.key:
          require.ensure(['@driftt/translations/languages/ka-GE.json'], (require) => {
            this.dispatch(
              TranslationConstants.TRANSLATION_LOADED,
              locale,
              require('@driftt/translations/languages/ka-GE.json')
            )
            resolve()
          })
          break
        default:
          const error = new Error(`Requested messages for invalid locale ${locale}`)
          captureException(error)
          reject(error)
      }
    })
  }
}

export default TranslationActions



// WEBPACK FOOTER //
// ./src/scripts/actions/TranslationActions.js